import { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";

function Block(props){

  const [goods, setGoods] = props.goods;
  const upsellsMeta = props.upsellsMeta;
  const upsellsCategoriesMeta = props.upsellsCategoriesMeta;
  const typesMap = props.typesMap;
  const index = parseInt(props.index);


  const handleInputChange = async (e) => {
    const {id, value} = e.target;

    if(id == "goods[" + index + "][type]"){

      var goodsNew = [...goods];
      goodsNew[index].type = value;
      goodsNew[index].id = false;

      setGoods(goodsNew);
    }

    if(id == "goods[" + index + "][id]"){

      var goodsNew = [...goods];
      goodsNew[index].id = value ? parseInt(value) : '';

      setGoods(goodsNew);
    }
  }


  const handleDelete = (e) => {

    var goodsNew = [...goods];
    goodsNew = goodsNew.filter((elem, i) => {
      return i !== index;
    });

    setGoods(goodsNew);
  }


  // const handleArrowUp = (e) => {
  //   if(index === 0){
  //     return false;
  //   }
  //
  //   var categoriesNew = [...categories];
  //   var temp = categoriesNew[index - 1];
  //   categoriesNew[index - 1] = categoriesNew[index];
  //   categoriesNew[index] = temp;
  //
  //   setCategories(categoriesNew);
  // }
  //
  // const handleArrowDown = (e) => {
  //   if( (index + 1) === categories.length){
  //     return false;
  //   }
  //
  //   var categoriesNew = [...categories];
  //   var temp = categoriesNew[index + 1];
  //   categoriesNew[index + 1] = categoriesNew[index];
  //   categoriesNew[index] = temp;
  //
  //   setCategories(categoriesNew);
  // }
  //
  //
  // function renderArrows(){
  //
  //   var arrowUp = null;
  //   var arrowDown = null;
  //
  //   if(index !== 0){
  //     arrowUp = (
  //       <span className="uk-margin-small-right uk-text-center" uk-icon="icon: chevron-up" onClick={handleArrowUp}></span>
  //     );
  //   }
  //
  //   if( (index + 1) !== categories.length){
  //     arrowDown = (
  //       <span className="uk-margin-small-right uk-text-center" uk-icon="icon: chevron-down" onClick={handleArrowDown}></span>
  //     );
  //   }
  //
  //   return (
  //     <>
  //       {arrowUp}
  //       {arrowDown}
  //     </>
  //   );
  // }


  function renderTypesOptions(){

    var options = [];

    Object.keys(typesMap).forEach((item, i) => {
      options.push(
        <option key={"good-type-option-" + index + "-" + i} value={item}>{typesMap[item]}</option>
      );
    });

    return options;
  }


  function renderUpsellsOptions(type = 'upsell'){

    const defaultOption = type == 'good' ? '-- Товар --' : '-- Категория --';
    const itemsMeta = type == 'good' ? upsellsMeta : upsellsCategoriesMeta;

    var options = [];
    options.push(
      <option key={"good-item-option-" + index + "-default"} value="">{defaultOption}</option>
    );

    var usedIds = [];

    for (var i = 0; i < goods.length; i++) {
      if(goods[i].type == type){
        usedIds.push(goods[i].id);
      }
    }

    for (var i = 0; i < itemsMeta.length; i++) {
      if( (goods[index].type == type && goods[index].id == itemsMeta[i].id) || !usedIds.includes(itemsMeta[i].id)){
        options.push(
          <option key={"good-item-option-" + index + "-" + i} value={itemsMeta[i].id}>{itemsMeta[i].name}</option>
        );
      }
    }

    return options;
  }


  return (
    <div className="uk-card uk-card-default uk-card-body uk-card-small">

      <div className="uk-flex uk-flex-middle">

        {/*<div className="uk-width-1-6">
          {renderArrows()}
        </div>*/}

        <div className="uk-width-1-3 uk-margin-right" id={"typeBox-" + index}>
          <div className="uk-form-controls">
            <select
              id={"goods[" + index + "][type]"}
              className="uk-select"
              name={"goods[" + index + "][type]"}
              onChange={handleInputChange}
              value={goods[index].type}
              required={true}
            >
              {renderTypesOptions()}
            </select>
          </div>
        </div>

        <div className="uk-width-1-2 uk-margin-right" id={"itemBox-" + index}>
          <div className="uk-form-controls">
            <select
              id={"goods[" + index + "][id]"}
              className="uk-select"
              name={"goods[" + index + "][id]"}
              onChange={handleInputChange}
              value={goods[index].id}
              required={true}
            >
              {renderUpsellsOptions(goods[index].type)}
            </select>
          </div>
        </div>

        <div className=" uk-text-center">
          <span className="uk-margin-small-right uk-text-center trash-button" data-good-index={index} uk-icon="icon: trash" onClick={handleDelete}></span>
        </div>

      </div>

    </div>
  );
}

export default Block;
